import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';

export const Conteiner = styled.div`
  display: flex;
  flex-direction: column;

  min-height: 100vh;
`;

export default createGlobalStyle`
  *{
    margin: 0;
    padding: 0;

    font-family: 'Roboto', sans-serif;

    :focus {
      outline: none;
    }

    :disabled {
      color: inherit;

      cursor: default;
      opacity: 0.7;
    }
  }

  body{
    display: flex;

    max-width:100vw;
    height: auto;
    min-height: 100vh;

    background-color: ${(props) => props.theme.BACKGROUND};
  }

  #root {
    width: 100vw;
    height: 100%;
    min-height: 100vh;
  }
`;
